"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeRate = exports.getSwapOutput = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const api_1 = require("../../../../api");
const bignumber_1 = require("../../../utils/bignumber");
const getPriceRatio_1 = require("../getPriceRatio/getPriceRatio");
const isRune_1 = require("../isRune/isRune");
const thorService_1 = require("../thorService");
const THOR_PRECISION = 8;
const getSwapOutput = (inputAmount, pool, toRune) => {
    const inputBalance = toRune ? pool.balance_asset : pool.balance_rune;
    const outputBalance = toRune ? pool.balance_rune : pool.balance_asset;
    const numerator = inputAmount.times(inputBalance).times(outputBalance);
    const denominator = inputAmount.plus(inputBalance).pow(2);
    return numerator.div(denominator);
};
exports.getSwapOutput = getSwapOutput;
const getDoubleSwapOutput = (input, inputPool, outputPool) => {
    if (inputPool && outputPool) {
        const runeToOutput = (0, exports.getSwapOutput)(input, inputPool, true);
        return (0, exports.getSwapOutput)(runeToOutput, outputPool, false);
    }
    if (inputPool && !outputPool) {
        return (0, exports.getSwapOutput)(input, inputPool, true);
    }
    if (!inputPool && outputPool) {
        return (0, exports.getSwapOutput)(input, outputPool, false);
    }
    return (0, bignumber_1.bn)(0); // We should never reach this, but this makes tsc happy
};
// https://docs.thorchain.org/how-it-works/prices
// TODO this does not support swaps between native "RUNE"
// Rune swaps use a different calculation because its 1 hop between pools instead of 2
const getTradeRate = async (sellAsset, buyAssetId, sellAmountCryptoPrecision, deps) => {
    // we can't get a quote for a zero amount so use getPriceRatio between pools instead
    if ((0, bignumber_1.bnOrZero)(sellAmountCryptoPrecision).eq(0)) {
        return (0, getPriceRatio_1.getPriceRatio)(deps, {
            sellAssetId: sellAsset.assetId,
            buyAssetId,
        });
    }
    const buyPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: buyAssetId });
    const sellPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId: sellAsset.assetId });
    if (!buyPoolId && !(0, isRune_1.isRune)(buyAssetId)) {
        throw new api_1.SwapError(`[getTradeRate]: No buyPoolId for asset ${buyAssetId}`, {
            code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
            fn: 'getTradeRate',
            details: { buyAssetId },
        });
    }
    if (!sellPoolId && !(0, isRune_1.isRune)(sellAsset.assetId)) {
        throw new api_1.SwapError(`[getTradeRate]: No sellPoolId for asset ${sellAsset.assetId}`, {
            code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
            fn: 'getTradeRate',
            details: { sellAsset: sellAsset.assetId },
        });
    }
    const { data } = await thorService_1.thorService.get(`${deps.daemonUrl}/lcd/thorchain/pools`);
    const buyPool = buyPoolId ? data.find((response) => response.asset === buyPoolId) : null;
    const sellPool = sellPoolId ? data.find((response) => response.asset === sellPoolId) : null;
    if (!buyPool && !(0, isRune_1.isRune)(buyAssetId)) {
        throw new api_1.SwapError(`[getTradeRate]: no pools found`, {
            code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
            fn: 'getTradeRate',
            details: { buyPoolId, sellPoolId },
        });
    }
    if (!sellPool && !(0, isRune_1.isRune)(sellAsset.assetId)) {
        throw new api_1.SwapError(`[getTradeRate]: no pools found`, {
            code: api_1.SwapErrorTypes.POOL_NOT_FOUND,
            fn: 'getTradeRate',
            details: { buyPoolId, sellPoolId },
        });
    }
    // All thorchain pool amounts are base 8 regardless of token precision
    const sellBaseAmount = (0, bignumber_1.bn)((0, bignumber_1.toBaseUnit)((0, bignumber_1.fromBaseUnit)(sellAmountCryptoPrecision, sellAsset.precision), THOR_PRECISION));
    const outputAmountBase8 = getDoubleSwapOutput(sellBaseAmount, sellPool, buyPool);
    const outputAmount = (0, bignumber_1.fromBaseUnit)(outputAmountBase8, THOR_PRECISION);
    return (0, bignumber_1.bn)(outputAmount)
        .div((0, bignumber_1.fromBaseUnit)(sellAmountCryptoPrecision, sellAsset.precision))
        .toString();
};
exports.getTradeRate = getTradeRate;
